export default {"src":"/_next/static/media/wand.55604d57.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};